import type {
  PlacementDetailsAllocatedJobShift,
  PlacementDetailsWorkRestriction,
} from 'src/store/placementDetailsPageSlice/types';

interface AssociateProfile {
  readonly name: string;
  readonly alias: string;
  readonly location: string;
  readonly employeeId: string;
  readonly managersName: string;
  readonly managersAlias: string;
  readonly shift: string;
  readonly personId: string;
  readonly jobTitle: string;
  readonly totalAccommodatedDays?: number;
}

interface AssociateProfilePlacement {
  readonly placementType: AssociateProfilePlacementType;
  readonly accommodationStatus: string;
  readonly accommodationId: number;
  readonly externalCaseId: string;
  readonly accommodationType: string;
  readonly allocatedJobShifts: PlacementDetailsAllocatedJobShift[];
  readonly additionalTags: string[];
  readonly injury: string;
  readonly updatedAt: string;
  readonly updatedBy: string;
  readonly startAt: string;
  readonly endAt: string;
  readonly timeInStatus: string;
  readonly transferAt: string;
  readonly transferredFrom: string;
  readonly newestJmrFileName: string;
  readonly modifiedShiftLength: number;
  readonly managerAlias: string;
  readonly fc: string;
  readonly workRestrictions: PlacementDetailsWorkRestriction[];
}

interface AssociateProfilePlacementsResponse {
  readonly pending: AssociateProfilePlacement[];
  readonly active: AssociateProfilePlacement[];
  readonly transferredIn: AssociateProfilePlacement[];
}

interface AssociateProfileRestriction {
  readonly placementType: AssociateProfilePlacementType;
  readonly accommodationId: number;
  readonly accommodationType: string;
  readonly externalCaseId: string;
  readonly updatedAt: string;
  readonly updatedBy: string;
  readonly taskName: string;
  readonly endAt: string;
  readonly hoursRestricted: string;
  readonly bodyLocation: string;
}

interface AssociateProfileRestrictionsResponse {
  readonly pending: AssociateProfileRestriction[];
  readonly active: AssociateProfileRestriction[];
  readonly transferredIn: AssociateProfileRestriction[];
}

export enum AssociateProfilePlacementType {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  TRANSFERRED = 'TRANSFERRED',
}

export type {
  AssociateProfile,
  AssociateProfilePlacement,
  AssociateProfilePlacementsResponse,
  AssociateProfileRestriction,
  AssociateProfileRestrictionsResponse,
};
